/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import { Row, Col, Typography, Collapse, Modal } from 'antd';
import moment from 'moment';
import './EventVersions.css';

const { Text, Link } = Typography;
const { Panel } = Collapse;

interface IProps {
  eventRevisions: any[];
  fetchNewEventRevision: (revisionId: number) => void;
}

const EventVersions: React.FC<IProps> = (props: IProps) => {
  const { eventRevisions, fetchNewEventRevision } = props;

  const confirmModal = (version: string, id: number) => {
    Modal.confirm({
      title: `Are you sure you want to revert to ${version}?`,
      okText: 'Yes',
      cancelText: 'Cancel',
      centered: true,
      onOk() {
        fetchNewEventRevision(id);
      },
    });
  };

  function renderEventRevisions(array: any[]) {
    if (array.length === 0) {
      return null;
    }
    return (
      <>
        <Row gutter={8}>
          <Col>
            <Text strong>Created:</Text>
          </Col>
          <Col>
            <Link
              onClick={() =>
                confirmModal('the original submission', array[0].id)
              }
            >
              {`${moment(array[0].createdOn).format('MM/DD/YY')} by ${
                array[0].createdBy
              }`}
            </Link>
          </Col>
        </Row>
        {array.map(
          (currEvent, index) =>
            index !== 0 &&
            index !== array.length && (
              <Row gutter={8} key={`er-${currEvent.id}`}>
                <Col>
                  <Text strong>Revision {index}:</Text>
                </Col>
                <Col>
                  <Link
                    onClick={() =>
                      confirmModal(`revision ${index}`, currEvent.id)
                    }
                  >
                    {`${moment(currEvent.createdOn).format('MM/DD/YY')} by ${
                      currEvent.createdBy
                    }`}
                  </Link>
                </Col>
              </Row>
            ),
        )}
        <Row gutter={8}>
          <Col>
            <Text strong>Latest Update:</Text>
          </Col>
          <Col>
            <Link
              onClick={() =>
                confirmModal('the latest update', array[array.length - 1].id)
              }
            >
              {`${moment(array[array.length - 1].createdOn).format(
                'MM/DD/YY',
              )} by ${array[array.length - 1].createdBy}`}
            </Link>
          </Col>
        </Row>
      </>
    );
  }

  const displayEventRevisions = renderEventRevisions(eventRevisions);

  return (
    <Collapse className="EventVersions" accordion expandIconPosition="right">
      <Panel header="Versions" key="1">
        {displayEventRevisions}
      </Panel>
    </Collapse>
  );
};

export default EventVersions;
